/* Skinique theme JS: header, menus, reveal animations, accordions, cookie consent, toasts. */
(function () {
  'use strict';

  if (window.__skThemeInit) return;
  window.__skThemeInit = true;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- sticky header ---------- */
  var header = document.querySelector('[data-header]');
  var logoRow = document.querySelector('[data-header-logo-row]');
  var SCROLLED = ['bg-background/90', 'backdrop-blur-md', 'shadow-elegant', 'border-b', 'border-border'];
  var TOP = ['bg-background/80', 'backdrop-blur-sm'];
  var LOGO_OPEN = ['max-h-20', 'pt-4', 'pb-2'];
  var LOGO_CLOSED = ['max-h-0', 'pt-0', 'pb-0'];

  function onScroll() {
    if (!header) return;
    var scrolled = window.scrollY > 50;
    SCROLLED.forEach(function (c) { header.classList.toggle(c, scrolled); });
    TOP.forEach(function (c) { header.classList.toggle(c, !scrolled); });
    if (logoRow) {
      LOGO_OPEN.forEach(function (c) { logoRow.classList.toggle(c, !scrolled); });
      LOGO_CLOSED.forEach(function (c) { logoRow.classList.toggle(c, scrolled); });
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- mobile sticky booking CTA ---------- */
  /* Visible from page load so booking is always one tap away; only steps
     aside while the footer (which has its own booking button) is on screen. */
  var stickyBook = document.querySelector('[data-sk-sticky-book]');
  if (stickyBook) {
    var stickyFooterInView = false;
    var applyStickyBook = function () {
      var on = !stickyFooterInView;
      stickyBook.classList.toggle('is-on', on);
      stickyBook.setAttribute('aria-hidden', String(!on));
    };
    var stickyFooter = document.getElementById('contact');
    if (stickyFooter && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        stickyFooterInView = entries[0].isIntersecting;
        applyStickyBook();
      }).observe(stickyFooter);
    }
    applyStickyBook();
  }

  /* ---------- mobile menu ---------- */
  var menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      var open = mobileMenu.classList.toggle('hidden') === false;
      menuToggle.setAttribute('aria-expanded', String(open));
      menuToggle.querySelector('[data-icon-menu]').classList.toggle('hidden', open);
      menuToggle.querySelector('[data-icon-close]').classList.toggle('hidden', !open);
    });
    mobileMenu.addEventListener('click', function (e) {
      if (e.target.closest('a')) {
        mobileMenu.classList.add('hidden');
        menuToggle.setAttribute('aria-expanded', 'false');
        menuToggle.querySelector('[data-icon-menu]').classList.remove('hidden');
        menuToggle.querySelector('[data-icon-close]').classList.add('hidden');
      }
    });
  }

  /* ---------- dropdowns (header shop menu + shop nav) ---------- */
  document.querySelectorAll('[data-dropdown]').forEach(function (dd) {
    var toggle = dd.querySelector('[data-dropdown-toggle]');
    var panel = dd.querySelector('[data-dropdown-panel]');
    if (!toggle || !panel) return;
    var hideTimer;
    function show() { clearTimeout(hideTimer); panel.classList.remove('hidden'); toggle.setAttribute('aria-expanded', 'true'); }
    function hide() { panel.classList.add('hidden'); toggle.setAttribute('aria-expanded', 'false'); }
    dd.addEventListener('mouseenter', show);
    dd.addEventListener('mouseleave', function () { hideTimer = setTimeout(hide, 120); });
    toggle.addEventListener('click', function () {
      panel.classList.contains('hidden') ? show() : hide();
    });
    document.addEventListener('click', function (e) { if (!dd.contains(e.target)) hide(); });
  });

  /* ---------- reveal on scroll ---------- */
  /* Initial hidden state only applies under .sk-anim, so content stays visible
     when JS never runs. Elements already in the viewport reveal immediately;
     the observer only handles elements scrolled into view later. */
  document.documentElement.classList.add('sk-anim');
  var revealEls = document.querySelectorAll('.reveal');

  function revealEl(el) {
    var delay = parseInt(el.getAttribute('data-reveal-delay') || '0', 10);
    setTimeout(function () { el.classList.add('revealed'); }, delay);
  }

  if (reducedMotion || !('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) { el.classList.add('revealed'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        revealEl(entry.target);
      });
    }, { rootMargin: '0px 0px -40px 0px', threshold: 0.05 });
    revealEls.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.95) {
        revealEl(el);
      } else {
        io.observe(el);
      }
    });
  }

  /* ---------- single-open accordions ---------- */
  document.querySelectorAll('[data-accordion="single"]').forEach(function (group) {
    group.addEventListener('toggle', function (e) {
      var target = e.target;
      if (!(target instanceof HTMLDetailsElement) || !target.open) return;
      group.querySelectorAll('details[open]').forEach(function (other) {
        if (other !== target) other.open = false;
      });
    }, true);
  });

  /* ---------- smooth anchors ---------- */
  document.querySelectorAll('[data-anchor-link]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (!id || id.charAt(0) !== '#') return;
      var el = document.querySelector(id);
      if (!el) return;
      e.preventDefault();
      el.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth' });
    });
  });

  /* ---------- toast ---------- */
  window.skiniqueToast = function (title, description) {
    var container = document.getElementById('ToastContainer');
    if (!container) return;
    var toast = document.createElement('div');
    toast.className = 'pointer-events-auto bg-foreground text-primary-foreground rounded-xl px-5 py-4 shadow-lg border border-primary-foreground/10 max-w-xs translate-y-2 opacity-0 transition-all duration-300';
    var t = document.createElement('p');
    t.className = 'text-sm font-medium';
    t.textContent = title;
    toast.appendChild(t);
    if (description) {
      var d = document.createElement('p');
      d.className = 'text-xs text-primary-foreground/70 mt-0.5';
      d.textContent = description;
      toast.appendChild(d);
    }
    container.appendChild(toast);
    requestAnimationFrame(function () {
      toast.classList.remove('translate-y-2', 'opacity-0');
    });
    setTimeout(function () {
      toast.classList.add('translate-y-2', 'opacity-0');
      setTimeout(function () { toast.remove(); }, 300);
    }, 3000);
  };

  /* ---------- cookie consent (+ consent-gated GA4) ---------- */
  var CONSENT_KEY = 'skinique_cookie_consent';
  var banner = document.querySelector('[data-cookie-banner]');

  function loadGA4() {
    var id = window.__skiniqueGA4;
    if (!id || window.__gaLoaded) return;
    window.__gaLoaded = true;
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(id);
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = window.gtag || gtag;
    gtag('js', new Date());
    gtag('consent', 'default', { analytics_storage: 'granted', ad_storage: 'denied' });
    gtag('config', id);
  }

  function showBanner() {
    if (!banner) return;
    banner.classList.remove('hidden');
    requestAnimationFrame(function () {
      banner.classList.remove('translate-y-8', 'opacity-0');
    });
  }
  function hideBanner() {
    if (!banner) return;
    banner.classList.add('translate-y-8', 'opacity-0');
    setTimeout(function () { banner.classList.add('hidden'); }, 300);
  }

  var consent = null;
  try { consent = localStorage.getItem(CONSENT_KEY); } catch (e) { /* private mode */ }

  if (consent === 'accepted') loadGA4();
  if (!consent) setTimeout(showBanner, 1500);

  if (banner) {
    banner.querySelectorAll('[data-cookie-accept]').forEach(function (b) {
      b.addEventListener('click', function () {
        try { localStorage.setItem(CONSENT_KEY, 'accepted'); } catch (e) {}
        hideBanner();
        loadGA4();
      });
    });
    banner.querySelectorAll('[data-cookie-decline]').forEach(function (b) {
      b.addEventListener('click', function () {
        try { localStorage.setItem(CONSENT_KEY, 'declined'); } catch (e) {}
        hideBanner();
      });
    });
  }
  document.querySelectorAll('[data-cookie-reset]').forEach(function (b) {
    b.addEventListener('click', function () {
      try { localStorage.removeItem(CONSENT_KEY); } catch (e) {}
      showBanner();
    });
  });
})();
